import { Stack, Text } from '@chakra-ui/react'

import NotificationHero from 'components/notification-hero'
import TableList, { TableListRow } from 'components/table-list'
import { useUserContext } from 'contexts/user-context'

export default function AccountProfile() {
  const { user } = useUserContext()

  return (
    <Stack w="100%" direction="column" spacing="32px" mx={{ base: 0, xl: 24 }} maxW="1280px">
      <NotificationHero
        status="primary"
        icon={['fas', 'user']}
        title="Account Profile"
        message={
          <Text textStyle="body1" m={0}>
            User profile updates are not currently allowed. Please contact support to change your details.
          </Text>
        }
      />
      <TableList>
        <TableListRow label="First name" value={user?.given_name ?? ''} onClick={() => {}} />
        <TableListRow label="Last name" value={user?.family_name ?? ''} onClick={() => {}} />
        <TableListRow label="Email" value={user?.email ?? ''} onClick={() => {}} />
      </TableList>
    </Stack>
  )
}
